import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Clock } from 'lucide-react';
import { Switch } from '../../ui/switch';
import { getBackendUrl } from '../../../utils/api';

const API = `${getBackendUrl()}/api`;

export default function PixWaitPaymentSettings() {
  const [pixSettings, setPixSettings] = useState({
    pix_wait_payment: false,
    pix_expiry_minutes: 15
  });
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    loadPixSettings();
  }, []);

  const loadPixSettings = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/restaurant/pix-settings`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPixSettings({
        pix_wait_payment: response.data.pix_wait_payment || false,
        pix_expiry_minutes: response.data.pix_expiry_minutes || 15
      });
    } catch (err) {
      console.error('Error loading PIX settings:', err);
    }
  };

  const savePixSettings = async () => {
    setLoading(true);
    setSaved(false);
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API}/restaurant/pix-settings`, pixSettings, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      console.error('Error saving PIX settings:', err);
    }
    setLoading(false);
  };

  return (
    <div className="mt-6 p-5 bg-gradient-to-br from-green-500/10 to-emerald-500/10 border border-green-500/30 rounded-xl" data-testid="pix-wait-payment-settings">
      <div className="flex items-start space-x-3 mb-4">
        <div className="text-green-400 text-xl mt-0.5">
          <Clock className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <p className="text-green-400 text-sm font-semibold mb-1">Aguardar Pagamento PIX</p>
          <p className="text-gray-300 text-sm leading-relaxed">
            Quando ativo, pedidos com PIX autom&aacute;tico s&oacute; aparecem na tela de pedidos e impressora ap&oacute;s o pagamento ser confirmado.
          </p>
        </div>
      </div>
      
      <div className="flex items-center justify-between p-4 bg-white/5 rounded-lg mb-4">
        <div className="flex-1">
          <p className="text-white font-medium">Enviar pedido somente ap&oacute;s pagamento</p>
          <p className="text-gray-400 text-xs mt-1">
            {pixSettings.pix_wait_payment 
              ? 'Pedidos PIX ficam retidos at\u00E9 confirma\u00E7\u00E3o do pagamento' 
              : 'Pedidos PIX v\u00E3o direto para a tela de pedidos'}
          </p>
        </div>
        <Switch
          checked={pixSettings.pix_wait_payment}
          onCheckedChange={(checked) => setPixSettings({ ...pixSettings, pix_wait_payment: checked })}
          data-testid="pix-wait-payment-toggle"
        />
      </div>

      {pixSettings.pix_wait_payment && (
        <div className="p-4 bg-white/5 rounded-lg mb-4">
          <label className="text-white text-sm font-medium mb-2 block">
            Tempo limite para pagamento (minutos)
          </label>
          <div className="flex items-center space-x-3">
            <input
              type="range"
              min="5"
              max="60"
              value={pixSettings.pix_expiry_minutes}
              onChange={(e) => setPixSettings({ ...pixSettings, pix_expiry_minutes: parseInt(e.target.value) })}
              className="flex-1 accent-green-500"
              data-testid="pix-expiry-slider"
            />
            <span className="text-white font-bold text-lg min-w-[50px] text-center" data-testid="pix-expiry-value">
              {pixSettings.pix_expiry_minutes} min
            </span>
          </div>
          <p className="text-gray-400 text-xs mt-2">
            Pedidos n&atilde;o pagos dentro deste prazo ser&atilde;o cancelados automaticamente.
          </p>
        </div>
      )}

      <button
        onClick={savePixSettings}
        disabled={loading}
        className="w-full px-4 py-3 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white rounded-lg font-medium transition-colors"
        data-testid="pix-settings-save-button"
      >
        {loading ? 'Salvando...' : saved ? 'Salvo!' : 'Salvar Configura\u00E7\u00F5es PIX'}
      </button>
    </div>
  );
};


// Settings Content Component


// Customers Content Component

// Delivery Zones Content Component
// DeliveryZonesContent extraido -> components/content/DeliveryZonesContent.js (Fase 2 refactor)


// CustomersContent extraido -> components/content/CustomersContent.js (Fase 2 refactor)


// CashbackContent extraido -> components/content/CashbackContent.js (Fase 2 refactor)

// Reports Content Component


// Settings Content Component
